import { useState } from 'react';
import { toast } from 'sonner';
import { applyVinFields, filledFieldNames, lookupVin } from '@/utils/vinLookup';

export default function VinLookupButton({ vin, token, formData, onApply, disabled }) {
  const [loading, setLoading] = useState(false);
  const ready = String(vin || '').trim().length === 17;

  const handleClick = async () => {
    if (!ready || loading || disabled) return;
    setLoading(true);
    try {
      const data = await lookupVin(vin, token);
      const fields = data?.fields || {};
      const names = filledFieldNames(fields);
      if (data?.ok && names.length) {
        onApply((prev) => applyVinFields(prev || formData, fields));
        toast.success(`Filled ${names.join(', ')}`);
        if (Array.isArray(data.warnings) && data.warnings.length) {
          toast.warning(data.warnings[0]);
        } else if (data.error_code && data.error_code !== '0') {
          toast.warning(data.error_text || 'VIN decoded with warnings');
        }
      } else {
        toast.error(data?.error_text || 'No vehicle data found for this VIN');
      }
    } catch (error) {
      const message = error.response?.data?.detail || 'VIN lookup failed';
      toast.error(typeof message === 'string' ? message : 'VIN lookup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={!ready || loading || disabled}
      className="mt-2 min-h-11 px-4 py-2 text-base font-['Manrope'] font-semibold bg-blue-500 hover:bg-blue-600 text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      data-testid="vin-lookup-btn"
    >
      {loading ? 'Looking up…' : 'VIN Lookup'}
    </button>
  );
}
